import { csrf } from './headers/csrf';
import { xWixBrand } from './headers/x-wix-brand';
import { consentPolicy } from './headers/consent-policy';
import { authorization } from './headers/authorization';
import { artifactId } from './headers/artifact-id';
import { commonConfig } from './headers/common-config';
import { linguistHeader } from './headers/linguist';
import { assertBoolean, assertString } from './assert';
export function createHeaders(opts = {}) {
    opts = Object.assign({ csrf: true, signedInstance: '' }, opts);
    verifyOptsOrThrow(opts);
    const headers = [
        xWixBrand(),
        consentPolicy(),
        authorization(opts.signedInstance),
        artifactId(opts.artifactId),
        commonConfig(),
        linguistHeader(Object.assign({ signedInstance: opts.signedInstance }, opts.multilingualOptions)),
    ];
    if (opts.csrf) {
        headers.push(csrf());
    }
    return headers
        .filter((hdrs) => Object.values(hdrs).every((v) => v))
        .reduce((result, hdrs) => (Object.assign(Object.assign({}, result), hdrs)), {});
}
function verifyOptsOrThrow(opts) {
    assertBoolean('opts.csrf', opts.csrf);
    assertString('opts.signedInstance', opts.signedInstance);
}
//# sourceMappingURL=index.js.map